import { render, staticRenderFns } from "./checkDetailNew.vue?vue&type=template&id=1c699ffb&scoped=true"
import script from "./checkDetailNew.vue?vue&type=script&lang=js"
export * from "./checkDetailNew.vue?vue&type=script&lang=js"
import style0 from "./checkDetailNew.vue?vue&type=style&index=0&id=1c699ffb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c699ffb",
  null
  
)

export default component.exports